import {combineReducers} from "redux";
import playShift from "./playShift";
import rebates from "./rebates";
import lotteryType from "./lotteryType";
import shift from "./shift";
import drawingShift from "./drawingShift";
import lotteryUser from "./lotteryUser";
import lotteryShift from "./lotteryShift";


const gameConfigReducer = combineReducers({
    playShift,
    rebates,
    lotteryType,
    shift,
    drawingShift,
    lotteryUser,
    lotteryShift
});
export default gameConfigReducer;